import { Component, OnInit, EventEmitter } from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";
import {AbstractControl, FormBuilder, FormGroup, Validators} from "@angular/forms";

@Component({
  selector: 'app-paid-commissions',
  templateUrl: './paid-commissions.component.html',
  styleUrls: ['./paid-commissions.component.scss']
})
export class PaidCommissionsComponent implements OnInit {

  closePaidCommission = new EventEmitter();
  paidForm: FormGroup;
  searchPlaceHolder: string = "value";
  searchCategoryOptions: any[] = [
    {label: "Customer Name", value: "customerName"},
    {label: "Contract Name", value: "contractName"},
    {label: "Utility Account Number", value: "utilityAccountNumber"},
    {label: "Search All", value: "searchAll"}
  ]

  constructor(private dialogRef: MatDialogRef<PaidCommissionsComponent>, private form: FormBuilder) {
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.paidForm = this.form.group({
      "searchCategory": ['', Validators.required],
      "searchValue": [''],
      "startDate": ['', Validators.required],
      "endDate": ['', Validators.required]
    })
    this.paidForm.get('searchCategory').valueChanges.subscribe(val => {
      let label = this.getCategoryLabel(val);
      this.searchPlaceHolder = label !== 'Search All' ? label: 'value';
      if(val === 'searchAll'){
        this.paidForm.get('searchValue').clearValidators();
      }else{
        this.paidForm.get('searchValue').setValidators(Validators.required);
      }
      this.paidForm.get('searchValue').setValue('');
      this.paidForm.get('searchValue').updateValueAndValidity();
    })
  }

  closeDialog(){
    this.closePaidCommission.emit();
  }

  getCategoryLabel(val){
    let label = null;
    for(let option of this.searchCategoryOptions){
      if(option.value === val){
        label = option.label;
        break;
      }
    }
    return label;
  }
  searchCategory(){
    return this.paidForm.get('searchCategory').value as string;
  }

}
